import { Tooltip, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import {
  PROFORMA_FUND_OWNERSHIP_BADGE_LABEL,
  PROFORMA_FUND_OWNERSHIP_MESSAGE,
} from 'common/constants/fund-ownership/fundOwnership';
import { ORANGE } from 'theme/prismDesignTokens';

const badgeSx: SxProps<Theme> = {
  alignItems: 'center',
  justifyContent: 'center',
  px: 1,
  borderRadius: 1,
  bgcolor: 'common.white',
  color: ORANGE[500],
  border: `1px solid ${ORANGE[500]}`,
  fontWeight: 700,
  fontSize: '0.6875rem',
  letterSpacing: 0.4,
};

// Reminds analysts that proforma fund ownership is never used for a valuation's fund
// conclusion -- only the primary cap table version's fund ownership is (SCAL-9332).
const ProformaFundOwnershipBadge = () => (
  <Tooltip title={PROFORMA_FUND_OWNERSHIP_MESSAGE} arrow>
    <Typography id="proforma-fund-ownership-badge" sx={badgeSx}>
      {PROFORMA_FUND_OWNERSHIP_BADGE_LABEL}
    </Typography>
  </Tooltip>
);

export default ProformaFundOwnershipBadge;
